var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoAgh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 430.66 836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "znak"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.94,833.05h36.13l-40-112.48C78.58,707.92,68.89,706,65.79,706H30.87c5.36,4.37,7.21,7.23,7.21,11.62,0,2.67-.59,4.71-3.51,13.33L0,833.05H23.61l10.45-31.68H76.21ZM69.54,781.7h-29l14.29-43.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.44,815V774.51c0-7.76-1.64-11.72-7.15-16.63h26.1a15,15,0,0,1,15,14.78v57.52A135.18,135.18,0,0,1,229.88,836c-45.17,0-73.8-26.34-73.8-65.32,0-38.06,28.69-67.71,74.42-67.71A85.76,85.76,0,0,1,259.75,708v25.43A53.19,53.19,0,0,0,230.5,725c-21.92,0-39.19,15.11-39.19,43,0,29.61,13.08,47.75,34.07,47.75A39.76,39.76,0,0,0,233.44,815Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M357.85,722.39a16.2,16.2,0,0,0-16-16.41H316.58c5.51,4.9,7.15,8.87,7.15,16.62V833.05h34.12V779.62h38.79v53.43h34V706.35h-34v51.72H357.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.1,621.26c28.25-19.41,52.95-49.42,53-113V127.08h28.23V508.3C388.29,578.9,353,607.14,307.1,621.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.07,621.26c26.47-12.35,72.36-35.3,72.36-113V127.08h28.23V508.3C430.66,603.61,356.54,617.73,330.07,621.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.45,621.26c21.08-21.19,28.24-63.53,28.24-120V127.08h28.25V508.3C345.94,571.65,324.76,603.61,289.45,621.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.8,0C180,19.41,204.74,49.42,204.75,113v437.7H233V113C233,42.36,197.68,14.12,151.8,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.76,0c26.47,12.36,72.36,35.3,72.36,113v437.7h28.23V113C275.35,17.65,201.23,3.53,174.76,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.15,0c21.07,21.18,28.23,63.54,28.23,120V550.66h28.25V113C190.63,49.61,169.45,17.65,134.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.62,621.26c-28.24-19.41-52.94-49.42-52.95-113V127.08H49.43V508.3C49.43,578.9,84.73,607.14,130.62,621.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.66,621.26C81.18,608.91,35.3,586,35.3,508.3V127.08H7.06V508.3C7.06,603.61,81.18,617.73,107.66,621.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.27,621.26C127.2,600.07,120,557.73,120,501.24V127.08H91.79V508.3C91.79,571.65,113,603.61,148.27,621.26Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAgh);
export default __webpack_public_path__ + "static/media/logo-agh.5fb5f9ff4b9b5d36dad44b54fe507799.svg";
export { ForwardRef as ReactComponent };